import { render, staticRenderFns } from "./atlasF.vue?vue&type=template&id=4738cf6e"
import script from "./atlasF.vue?vue&type=script&lang=js"
export * from "./atlasF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports